import { GET_POST, MOD_AUTO_COMPLETE, SHARE_CODE, UPDATE_PUBLISH_TAGS, UPDATE_WALL_NAME } from "./api";
import HttpClient from "./http-client";

export const IS = localStorage.getItem('access_token');


export const generatetagCode = (tags) => {
    const ownerId = localStorage.getItem('ownerId');
    const wallId = localStorage.getItem('wallId');
    return new HttpClient().post(`${UPDATE_PUBLISH_TAGS}`, {
        'ownerId': `${ownerId}`,
        'wallId': wallId,
        'tags': tags.join(),
    });
}



export const autoCompleteSearchPublish = (keyword, db_table) => {
    const wallId = localStorage.getItem('wallId');
    const ownerId = localStorage.getItem('ownerId')
    const type = 3;
    return new HttpClient().post(`${MOD_AUTO_COMPLETE}`, { ownerId: `${ownerId}`, db_table: db_table, keyword: keyword, wallId: wallId, feeds: "", type })

}
export const shareCode = (code) => {

    return new HttpClient().post(`${SHARE_CODE}`, {
        'htmlCode': code.htmlCode,
        'type': code.type,
        'email': code.email,
    })
}


export const getPOST = (getDATA) => {
    return new HttpClient().post(`${GET_POST}`, {
        'dbTable': getDATA.dbTable,
        'wallId': getDATA.wallId,
        'type': getDATA.type,
        'randomizePost': getDATA.randomizePost,
        'offset': getDATA.offset
    })
}



export const updateWall = (getdata) => {
    return new HttpClient().post(`${UPDATE_WALL_NAME}`, getdata)
}
